/**
 * A step's name in Title Case, wherever it is shown (Jason, 2026-10-06: "all of these node titles should be title case
 * everywhere"): every word capitalized but the small joining words inside a name (and, of, the), a word that already
 * holds a capital kept as it is (NSB, CAD, HVAC), and each part of a hyphenated word. The first and last words, and the
 * first after a colon or a dash, are always capitalized. What was typed is kept as typed; this is how it is shown.
 */
const SMALL = new Set(['a', 'an', 'and', 'as', 'at', 'but', 'by', 'for', 'from', 'in', 'into', 'nor', 'of', 'on', 'or', 'per', 'the', 'to', 'vs', 'via', 'with']);

export function titleCase(text: string): string {
  const words = text.split(' ');
  return words
    .map((word, i) => {
      const prev = i ? words[i - 1]! : '';
      const edge = i === 0 || i === words.length - 1 || prev.endsWith(':') || prev === '—' || prev === '–';
      return word
        .split('-')
        .map((part, k) => {
          const core = part.replace(/^[("“‘']+/, '');
          const lead = part.slice(0, part.length - core.length);
          if (!core) return part;
          const first = core[0]!;
          if (first !== first.toLowerCase() || /[A-Z]/.test(core.slice(1))) return part;
          if (!edge && k === 0 && SMALL.has(core.toLowerCase())) return part;
          return lead + first.toUpperCase() + core.slice(1);
        })
        .join('-');
    })
    .join(' ');
}
